import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import aboutImage from "../assets/loanInMinutes/Picture.png";
import Symbol_2 from "../assets/loanInMinutes/symbol_2.png"
import Symbol_3 from "../assets/loanInMinutes/symbol_3.png"

export const AboutUsSection = () => {
  return (
    <section className="relative overflow-hidden bg-white">
      {/* Rupee watermark — right edge */}
      <img
        src={Symbol_3}
        alt=""
        className="hidden sm:block absolute top-35 right-0 h-120 object-contain object-right opacity-100 pointer-events-none select-none z-0"
      />

      {/* ── MOBILE LAYOUT ── */}
      <div className="lg:hidden px-6 py-10 relative z-10">
        {/* Symbol watermark — top right, mobile only */}
        <img
          src={Symbol_2}
          alt=""
          className="absolute top-0 right-10 w-20 h-20 object-contain opacity-100 pointer-events-none select-none"
        />
        <h2 className="text-4xl font-bold text-[#1a1a4e] text-center mb-6">
          ABOUT US
        </h2>
        <div>
          <img
            src={aboutImage}
            alt="Loan In Seconds"
            className="w-full max-h-80 mb-5 object-cover object-top rounded-xl"
          />
          <p className="text-gray-600 text-base leading-relaxed text-center">
            At Loan In Seconds, we believe financial support should be fast,
            simple, and accessible. Our platform connects individuals with
            personalized loan solutions through a secure and fully digital
            experience. We work to simplify the borrowing journey by reducing
            paperwork, saving time, and providing transparent processes.
            Whether you're managing an emergency, planning a major expense, or
            pursuing a personal goal, we're here to help you access funds with
            confidence. Our mission is to make financial assistance quicker,
            smarter, and more convenient for every customer.
          </p>
        </div>
        <div className="text-center mt-6">
          <Link
            to="#"
            className="inline-flex items-center gap-2 text-[#CC1A1A] font-semibold text-base hover:gap-3 transition-all duration-200"
          >
            {/* Read More <span className="text-lg">→</span> */}
          </Link>
        </div>
      </div>

      {/* ── DESKTOP LAYOUT ── */}
      <div className="hidden lg:flex max-w-7xl mx-auto py-20 flex-row min-h-[600px] relative z-10">

        {/* Left — Image */}
        <div className="w-[45%] flex-shrink-0 relative">
          <img
            src={aboutImage}
            alt="Loan In Seconds"
            className="absolute top-0 right-[7vw] h-full w-screen object-cover object-center"
            style={{ minHeight: "480px" }}
          />
        </div>

        {/* Right — Content */}
        <div className="w-[55%] flex items-center py-16 relative">
          <div className="relative z-10 max-w-xl">
            <h2 className="text-4xl xl:text-5xl font-bold text-[#1a1a4e] mb-5">
              ABOUT US
            </h2>
            <p className="text-gray-500 text-base leading-[1.9] mb-10 max-w-lg">
              At Loan In Seconds, we believe financial support should be fast,
              simple, and accessible. Our platform connects individuals with
              personalized loan solutions through a secure and fully digital
              experience. We work to simplify the borrowing journey by reducing
              paperwork, saving time, and providing transparent processes.
              Whether you're managing an emergency, planning a major expense, or
              pursuing a personal goal, we're here to help you access funds with
              confidence. Our mission is to make financial assistance quicker,
              smarter, and more convenient for every customer.
            </p>
            <Link
              to="#"
              className="inline-flex items-center gap-2 text-[#CC1A1A] font-semibold text-base hover:gap-3 transition-all duration-200"
            >
              {/* Read More <span className="text-lg">→</span> */}
            </Link>
          </div>
        </div>

      </div>
    </section>
  );
};

const AboutUs = () => {
  return (
    <div className="bg-white min-h-screen">
      <Navbar />
      <div className="pt-[73px]">
        <AboutUsSection />
      </div>
    </div>
  );
};

export default AboutUs;
